var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArticleFallback = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65.4921,
    height: 64.9688,
    transform: "translate(0 0.909058)",
    fill: "#EDE9E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.746 16.9091L49.4921 22.1422L32.746 27.3753L16 22.1422L32.746 16.9091Z",
    fill: "#C5B9AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.746 16.9091L49.4921 22.1422L32.746 27.3753L16 22.1422L32.746 16.9091Z",
    fill: "#EDE9E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4921 22.1422L32.746 27.1137V49.8778L49.4921 44.6447V22.1422Z",
    fill: "#C5B9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4921 22.1422L32.746 27.1137V49.8778L49.4921 44.6447V22.1422Z",
    fill: "#C5B9AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.1422L32.746 27.1137V49.8778L16 44.6447V22.1422Z",
    fill: "#C5B9AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.1422L32.746 27.1137V49.8778L16 44.6447V22.1422Z",
    fill: "#C5B9AC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22.1422L32.746 27.1137V49.8778L16 44.6447V22.1422Z",
    fill: "#7B6469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.1422L32.746 27.1137V49.8778L16 44.6447V22.1422Z",
    fill: "#7B6469"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2978 40.1425L22.9044 36.3889H20.8452C20.7282 36.3889 20.6457 36.3466 20.5978 36.2619C20.5499 36.1772 20.5579 36.0879 20.6217 35.9938L24.1494 30.5469H24.756L24.1494 34.2864H26.1766C26.2937 34.2864 26.3788 34.3287 26.432 34.4134C26.4853 34.498 26.4853 34.5874 26.432 34.6815L22.9044 40.1425H22.2978Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.474 24.0229V27.637L39.0258 29.2069V25.4129L22.8031 20.0489L27.2513 18.6262L43.474 24.0229Z",
    fill: "#C5B9AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.474 24.0229V27.637L39.0258 29.2069V25.4129L22.8031 20.049L43.474 24.0229Z",
    fill: "#EDE9E5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArticleFallback);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Article fallback.ec56e1e6f2098415dcc9e74374878946.svg";